import React from 'react';
import Grid from '@material-ui/core/Grid';
import Logo from './../../assets/logo-rede-convida-home.png';
import './../Tela_Home/style.css';

export default function Tela_Home() {    
    return(
        <>     
        <head>
            <title> ESSE SITE FOI REDIRECIONADO PARA A URL:</title>
        </head> 
        <body id="bg-home">

                <Grid container spacing={0} direction="row" justify="center" alignItems="center" style={{ minHeight: '80vh', maxWidth: '100%' }}> 
                    <Grid item xs={1}></Grid>
                    
                    <Grid item xs={3} align="center">
                        <img src={Logo} alt="Logo da Home" id="img-home"></img>
                        <div>
                        <br></br>
                        <h1 id="p-home">ESSE SITE FOI REDIRECIONADO PARA OUTRO LINK</h1>
                        <br></br>
                        <h2><a href="https://redeconvidateleatendimento.netlify.app/">Visite nosso site clicando aqui</a></h2>
                        <br></br>
                        <p>Ou acesse esse link: https://redeconvidateleatendimento.netlify.app/</p>
                        </div>
                    </Grid>
                    
                    <Grid item xs={1}></Grid>
                </Grid>

        </body>
        </>
    );
}

/*
<SideNav />
            <body id="bg-home">

                <Grid container spacing={0} direction="row" justify="flex-end" alignItems="flex-start" style={{maxWidth: '100%', marginTop: '65px'}}>
                    <Grid item xs={2}><NavLink id="a-home" to="/Tela_Login_Organizador"><p id="p-tittle-og">Organizador</p></NavLink></Grid>
                </Grid>
                

                <Grid container spacing={0} direction="row" justify="center" alignItems="center" style={{ minHeight: '80vh', maxWidth: '100%' }}> 
                    <Grid item xs={1}></Grid>
                    <Grid item xs={3} align="center">
                        <img src={DrawRight} alt="Esquerda" id="resize"></img>
                        <NavLink id="a-home" to="/Tela_PS"> <button id="One">Sou Profissional da Saúde</button></NavLink>
                    </Grid>
                    
                    <Grid item xs={3} align="center">
                        <img src={Logo} alt="Logo da Home" id="img-home"></img>
                        <h2 id="p-home">Plataforma de Teleatendimento de Saúde</h2>
                    </Grid>
                    
                    <Grid item xs={3} align="center">                        
                        <img src={DrawLeft} alt="Esquerda" id="resize"></img>
                        <NavLink id="a-home" to="/RI"><button id="Two">Sou Representante de Instituição</button></NavLink>
                    </Grid>
                    <Grid item xs={1}></Grid>
                </Grid>
                
            </body> 
*/